import { StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';

export const styles = StyleSheet.create({
  statsHead: {
    paddingTop: 10,
    paddingHorizontal: 12,
  },
  container: {
    width: '100%',
  },
  scrollView: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
  },
  bullets: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    width:'100%',
  },
  bullet: {
    paddingHorizontal: 5,
  }
});

export default styles;